<template>
  <div>
    <div class="SelectTreeCom">
      <div class="navHeader">
        <van-icon name="arrow-left" @click="onClickLeft"/>
        选择区域
      </div>
      <div class="select-tree-com">
        <div class="searchInput">
          <van-search v-model="searchText" placeholder="请输入区域名称" @search="search" :clearable="false"/>
        </div>
        <div class="treeComponent" v-if="treeData.length">
          <div class="header">
            <div>
              当前选中:{{ selectRow.dictName }}
            </div>
            <span @click="save">确定</span>
          </div>
          <TreeItem

              class="tree-item" v-for="treeNode in treeData" :key="treeNode.id" :tree-node="treeNode"
              @checkItem="checkItem"
              @select="treeSelect"
          ></TreeItem>

        </div>
        <div v-else style="height: 50vh;display:flex;justify-content: center;align-items: center">
          <p>暂未配置数据</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import TreeItem from "./treeItem"

export default {
  name: 'SelectTreeCom',
  components: {
    TreeItem
  },
  props: {
    // 结构数据
    lists: {
      type: Array,
      default() {
        return []
      }
    },
    // 是否开启checkbox
    checkbox: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      treeData: [],
      treeDataCapy: [],
      checkList: [],
      searchText: '',
      selectRow: {},
      uId: ''

    };
  },
  watch: {
    lists: {
      handler(newV) {
        console.log('selectTreeeCom组件lists', newV);
        // this.treeData = [...newV]
      },
      // immediate: true
    }
  },
  created() {
  },
  mounted() {
    this.request({
      url: '/deptCascadeDictData/listDeptCascadeDictDataTree',
      params: {
        dictId: this.$route.query.uId
      }
    }).then(res => {
      if (res.data.code == 1000) {
        this.treeData = res.data.result
        this.treeDataCapy = JSON.parse(JSON.stringify(res.data.result))
        this.selectRow.dictName = this.$route.query.dictName
        this.selectRow.dictId = this.$route.query.dictId
        this.selectRow.uId = this.$route.query.uId
        this.setCheckedFalse(this.treeData, false, this.$route.query.dictId)
      }
    })
  },
  methods: {
    save() {
      let {uId, dictName} = this.selectRow
      if (uId && dictName) {
        let obj = JSON.parse(localStorage.getItem('addInfo')) || {}
        obj[this.$route.query.fieldName] = uId
        obj[this.$route.query.fieldShowName] = dictName
        localStorage.setItem('addInfo', JSON.stringify(obj))
        this.$router.go(-1)
      }
    },
    search() {
      let arr = this.treeToOneArr(this.treeData)
      let searchArr = []
      if (this.searchText) {
        arr.map(item => {
          if (item.dictName.indexOf(this.searchText) > -1) {
            searchArr.push(item)
          }
        })
        this.treeData = searchArr
      } else {
        this.treeData = this.treeDataCapy
      }
    },
    setCheckedFalse(node, checked, id) {
      node && node.map(item => {
        item.checked = checked
        if (id == item.uId) {
          console.log(id)
          item.checked = true
        }
        if (item.children?.length > 0) {
          item.children.map(it => {
            it.checked = false
            if (id == it.uId) {
              console.log(it)
              it.checked = true
            }
            this.setCheckedFalse(it.children, checked, id);
          })

        }
      })
    },
    treeSelect(item) {
      if (item != undefined) {
        this.setCheckedFalse(this.treeData, false,)
        item.checked = true
        let arr = item.cascadeId.split(',')
        let data = this.treeToOneArr(this.treeData)
        let newArr = []
        data.map(item => {
          arr.map(it => {
            if (item.uId === it) {
              newArr.push(item.dictName)
            }
          })
        })
        newArr = newArr.reverse()
        let str = ''
        newArr.map(it => {
          str += it
        })
        this.selectRow = JSON.parse(JSON.stringify(item))
        this.selectRow.dictName = str
      }


    },
    onClickLeft() {
      this.$router.go(-1)
    },
    // 拿到当前选中的所有item数据
    checkItem(item) {
      // console.log(item)
      // console.log('selectcom-checkItem',item);
      let newArr = []
      newArr = this.flattenNodes(item)
      // console.log('newArr', newArr);
      // 存储选中的！
      newArr && newArr.length && newArr.forEach(item => {
        if (item.checked) {
          this.checkList.push(item)
        }
      });
      // console.log('存储选中的-this.checkList', this.checkList);
      // 处理再一次选中时 包含之前的选项，覆盖之前的选项 check
      this.checkList && this.checkList.length && this.checkList.forEach(itemB => {
        newArr.some(itemA => {
          if (itemA.id === itemB.id) {
            itemB.checked = itemA.checked
          }
        })
      })
      // console.log('处理this.checkList', this.checkList);
      // 过滤掉 check为false 得到实际选中的数据
      this.checkList = this.checkList.filter(item => {
        if (item.checked) {
          return item;
        }
      })
      // console.log('res-this.checkList',this.checkList);
      // 去重
      let uniqueArr = []
      uniqueArr = Array.from(new Set(this.checkList.map(item => item.id))).map(id => this.checkList.find(item => item.id === id));
      // console.log('uniqueArr', uniqueArr);
      this.$emit('getCheckList', uniqueArr)
    },
    // 把树对象 扁平化为父+子的数据
    flattenNodes(data) {
      let nodes = [];
      // 添加当前节点到结果数组中
      nodes.push({
        name: data.name,
        checked: data.checked,
        deptCode: data.deptCode,
        dictName: data.dictName
      });
      // 遍历子级节点并递归处理
      if (data.children && data.children.length > 0) {
        for (let child of data.children) {
          nodes = nodes.concat(this.flattenNodes(child));
        }
      }
      return nodes;
    },
    // 全选
    setCheckAll(params) {
      // console.log('setCheckAll',params);
      const allTreeData = this.treeToOneArr(this.treeData)
      if (params) {
        this.checkList = [...allTreeData]
        return this.checkList
      } else {
        this.checkList = []
        return this.checkList
      }
    },
    // 取消全选
    cancelCheckAll() {
      this.checkList = []
    },
    // tree数据 扁平化
    treeToOneArr(arr) {
      const data = JSON.parse(JSON.stringify(arr))
      const newData = []
      const hasChildren = item => {
        (item.children || (item.children = [])).map(v => {
          hasChildren(v)
        })
        delete item.children
        newData.push(item)
      }
      data.map(v => hasChildren(v))
      return newData
    },
    oneArrToTree(data) {
      // 对源数据深度克隆
      const cloneData = JSON.parse(JSON.stringify(data))
      // filter嵌套filter相当于for循环嵌套for循环
      const result = cloneData.filter(parent => {
        // 返回每一项的子级数组
        const branchArr = cloneData.filter(child => parent.parentCode === child.parentCode)

        // 若子级存在，则给子级排序；且，赋值给父级
        if (branchArr.length > 0) {
          branchArr.sort(this.compare('order'))
          parent.children = branchArr
        }
        // 返回最高的父级，即，parent_id为0，
        return parent.parentCode === '00'
      })
      // 给最高级的父级排序
      result.sort(this.compare('order'))
      return result
    },
    // 对象数组排序
    compare(property) {
      return function (a, b) {
        const value1 = a[property]
        const value2 = b[property]
        return value1 - value2// 升序,降序为value2 - value1
      }
    },
  }

};
</script>

<style lang="scss" scoped>
.navHeader {
  text-align: center;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
  height: 44px;
  line-height: 44px;
  position: relative;

  i {
    position: absolute;
    top: 12px;
    left: 16px;
  }
}

.select-tree-com {
  padding: 10px 24px;
}

.tree-item {
  line-height: 34px;
}

.SelectTreeCom {
  min-height: 100vh;

  .select-tree-com {
    height: calc(100vh - 60px);
    background: #f6f6f6;
    padding: 10px 15px 0px;

    .searchInput {
      height: 36px;
      margin-bottom: 10px;

      .van-search {
        padding: 0 !important;
        height: 36px;
        line-height: 28px;
      }

      .van-search__content {
        background: #fff !important;
      }

      .van-icon-search {
        font-size: 22px;
      }
    }

    .treeComponent {
      padding: 0 20px;
      border-radius: 10px;
      background: #fff;
      height: calc(100% - 40px);
      overflow-y: auto;

      .header {
        height: 50px;
        line-height: 50px;
        display: flex;
        box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 0.5);
        justify-content: space-between;

        > div {
          font-size: 16px;
          color: #464A4C;
          letter-spacing: 0;
          font-weight: 400;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 76%;
        }

        > span {
          font-size: 16px;
          color: #208FFF;
          letter-spacing: 0;
          font-weight: 500;
          width: 100px;
          text-align: right;
        }
      }
    }
  }
}
</style>

